// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ecommerce__account',
    // #endregion
    // #region Data
    data: () => ({
        isOpen: false,
    }),
    computed: {
        currentUser() {
            return this.$host.store.get("session").currentUser;
        },
        accountDisplayName() {
            if (!this.currentUser) {
                return '';
            }
            return this?.currentUser?.accountName ?? '';
        },
    },
    // #endregion
    // #region Core
    methods: {
        toogleButton_Account() {
            this.isOpen = !this.isOpen;
        },
        closeDropdown() {
            this.isOpen = false;
        },
    },
    // #endregion
});
// #endregion
